import { h, Component } from 'preact'
import _ from './styles.sass'
import colorScale from '@root/lib/colorScale'
import chartJsLinesPlugin from '@root/lib/chartJsLinesPlugin'
import chartJsNoxTooltipPlugin from '@root/lib/chartJsNoxTooltipPlugin'

import Chart from 'chart.js'

export default class DayGraph extends Component {
  generateChart = () => {
    const { station } = this.props

    Chart.defaults.global.defaultFontFamily = 'Interstate'

    const ctx = this.canvas.getContext('2d')
    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        datasets: [
          {
            label: 'Tageswerte',
            data: station.properties.todaysHourValues,
            borderColor: 'black',
            borderWidth: 4,
            pointRadius: 0,
            fill: false,
            lineTension: 0
          }
          // ...station.properties.last12MonthsHourValues.map(values => ({
          //   label: 'Tageswerte',
          //   data: values,
          //   borderColor: 'rgba(180, 180, 180, 0.05)',
          //   borderWidth: 1.5,
          //   pointRadius: 1,
          //   showLine: false,
          //   fill: false,
          //   lineTension: 0
          // }))
        ]
      },
      plugins: [chartJsLinesPlugin, chartJsNoxTooltipPlugin],
      options: {
        responsive: false,
        maintainAspectRatio: false,
        events: ['mousemove'],
        animation: {
          duration: 0
        },
        legend: {
          display: false,
          padding: 0
        },
        layout: {
          padding: {
            left: 30,
            right: 20,
            top: 10,
            bottom: 0
          }
        },
        scales: {
          xAxes: [{
            gridLines: {
              color: '#eeeeee',
              drawOnChartArea: false
            },
            ticks: {
              maxRotation: 0,
              autoSkipPadding: 5,
              padding: 10,
              callback: (label, index, all) => {
                // if (index !== 0 && index < all.length - 1) return label
                return label + ' Uhr'
              }
            }
          }],
          yAxes: [{
            display: false,
            ticks: {
              beginAtZero: true,
              min: 0,
              max: 100
            }
          }]
        },
        tooltips: {
          enabled: false
        }
      }
    })
  }

  checkSize = () => {
    if (!this.container) return

    const width = this.container.clientWidth
    const height = this.container.clientHeight

    if (this.prevWidth !== width || this.prevHeight !== height) {
      this.prevWidth = width
      this.prevHeight = height
      this.chart.resize()
      this.updateGradient()
    }
  }

  updateGradient = () => {
    const height = this.chart.chartArea.bottom

    const ctx = this.canvas.getContext('2d')
    const gradientStroke = ctx.createLinearGradient(0, height, 0, 0)

    colorScale.colors(11).forEach((color, i) => {
      gradientStroke.addColorStop(i / 10, color)
    })

    this.chart.data.datasets[0].borderColor = gradientStroke
    this.chart.update()
  }

  shouldComponentUpdate (nextProps) {
    return nextProps.station.properties.id !== this.props.station.properties.id
  }

  componentDidUpdate () {
    const { station } = this.props

    this.chart.data.datasets = this.chart.data.datasets.map((dataset, i) => {
      if (i === 0) {
        dataset.data = station.properties.todaysHourValues
      } else {
        // dataset.data = station.properties.last12MonthsHourValues[i - 1]
      }
      return dataset
    })

    this.chart.update()
    this.chart.resize()
  }

  componentDidMount () {
    this.generateChart()
    this.intervalId = setInterval(this.checkSize, 50)
  }

  componentDidUnMount () {
    clearInterval(this.intervalId)
  }

  render () {
    return <div class={_.chartContainer} ref={container => { this.container = container }}>
      <canvas class={_.canvas} key='canvas' ref={canvas => { this.canvas = canvas }} />
    </div>
  }
}
